module.exports = __webpack_public_path__ + "img/user-stroke-white.cfcc712c.svg";